import axios from 'axios'

class BaseApi {
  constructor(baseURL) {
    this.instance = axios.create({ baseURL })
  }
}

export { BaseApi }
